import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_ROOT } from './services/api-service';
import { AuthSessionService } from './services/auth-session.service';

export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const authSession = inject(AuthSessionService);
  const apiRoot = inject(API_ROOT);
  const token = authSession.getAccessToken();

  if (!token || !request.url.startsWith(apiRoot) || request.headers.has('Authorization')) {
    return next(request);
  }

  return next(request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  }));
};
